import React, { createContext, useCallback, useContext, useState } from 'react';

import AccessModalV2 from 'common/modals/AccessModalV2';

import type { RolePermissionName } from 'common/api/endpoints/companies';

export type OpenAccessModalContextType = (requiredPermissions: RolePermissionName[]) => void;

export const OpenAccessModalContext = createContext<OpenAccessModalContextType>(() => undefined);

export const useAccessModal = () => {
  const openAccessModal = useContext(OpenAccessModalContext);

  return (requiredPermissions: RolePermissionName[]) => {
    openAccessModal(requiredPermissions);
  };
};

type AccessModalContainerProps = {
  children: React.ReactNode;
};

const AccessModalContainer = ({ children }: AccessModalContainerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [requiredPermissions, setRequiredPermissions] = useState<RolePermissionName[]>([]);

  const openAccessModalV2 = useCallback((permissions: RolePermissionName[]) => {
    setRequiredPermissions(permissions);
    setIsOpen(true);
  }, []);

  const handleOpenChange = useCallback((open: boolean) => {
    setIsOpen(open);
    if (!open) {
      setRequiredPermissions([]);
    }
  }, []);

  return (
    <OpenAccessModalContext.Provider value={openAccessModalV2}>
      {children}
      <AccessModalV2
        isOpen={isOpen}
        onOpenChange={handleOpenChange}
        requiredPermissions={requiredPermissions}
      />
    </OpenAccessModalContext.Provider>
  );
};

export default AccessModalContainer;
